import { render, staticRenderFns } from "./SaldoSalida.vue?vue&type=template&id=c3a97614&scoped=true"
import script from "./SaldoSalida.vue?vue&type=script&lang=js"
export * from "./SaldoSalida.vue?vue&type=script&lang=js"
import style0 from "./SaldoSalida.vue?vue&type=style&index=0&id=c3a97614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a97614",
  null
  
)

export default component.exports